import React, { useEffect, useState } from "react";
import BannerSection from "./BannerSection";
import "./css/Facility.css";

const Facilities = () => {
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Scroll animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    const cards = document.querySelectorAll(".animate-on-scroll");
    cards.forEach(card => observer.observe(card));

    return () => {
      cards.forEach(card => observer.unobserve(card));
    };
  }, [facilitiesData]);

  // Fetch dynamic facilities data
  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PROJECT_PATH}/items/facilities?fields=*.*.*`,
          { cache: "no-store" }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.status}`);
        }

        const json = await response.json();

        const formattedData = json.data.map((item, index) => ({
          id: item.id,
          title: item.facilitiesname || "No Title",
          description: item.facilitiesdetails || "No Description",
          image: item.facilitiesimage?.data?.full_url?.replace("http://", "https://") || "",
          colorClass: `card-color-${(index % 7) + 1}`, // loop color classes from 1 to 7
        }));
 
        setFacilitiesData(formattedData);
      } catch (error) {
        console.error("Error fetching facilities:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFacilities();
  }, []);

  if (loading) {
    return <div className="text-center my-5">Loading facilities...</div>;
  }

  return (
    <div className="container-fluid p-0">
      <BannerSection />
      <div className="container liscontainer">
        <div className="facilitycontent">
          {facilitiesData.map(({ id, title, image, description, colorClass }) => (
            <div key={id} className={`facilitCard animate-on-scroll ${colorClass}`}>
              <div className="facilimages">
                <img src={image} alt={title} />
              </div>
              <div className="facontent">
                <div className="factitle">{title}</div>
                <p>{description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Facilities;
